import styled, { keyframes } from "styled-components";
import IconUpdating from "../Icons/IconUpdating";

export const SpinnerContainer = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 24px 0px;
`;

const spin = keyframes`
 0% {
		transform: rotate(0deg);
	}
	
	100% {
		transform: rotate(360deg);
	}
`;

export const Spinner = styled(IconUpdating)`
  animation: ${spin} 1s linear infinite;
`;

export const UpdatingText = styled.div<{ color?: string }>`
  margin-top: 8px;
  color: ${({ theme, color }) => (color ? theme[color] : theme.white)};
`;
